import MapContactPersons from '../modules/map-contact-boxes';

const sections = document.querySelectorAll('[data-map-contact-persons]');
const initMapContactPersons = sections => {
    if (sections) {
        sections.forEach(section => new MapContactPersons(section));
    }
};

initMapContactPersons(sections);
